/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

type ListItemProps = {
  active: boolean;
  content?: React.ReactNode;
  divider: boolean;
};

export const ListItem = ({
  active = false,
  content,
  divider = false,
}: ListItemProps): JSX.Element => {
  return (
    <div>
      <div css={[styles.item, !active && styles.itemDisabled]}>
        {content && content}
      </div>
      {divider && <div css={styles.divider} />}
    </div>
  );
};

const styles = {
  item: css`
    display: flex;
    padding: 12px 16px;
    background-color: white;
    justify-content: space-between;
    cursor: pointer;
  `,
  itemDisabled: css`
    background-color: #f7f7f7ff;
    cursor: default;
    padding: 12px;
  `,

  divider: css`
    border-bottom: 1px solid #d2d2d2ff;
    margin: 0;
  `,
};
